export default {
  notFound: "The form/questionnaire is not found!",
};
